export default {
    events: state => {
        return state.events
    },
    userTimezone: state => state.userTimezone,
    timezoneNamedList (state) {
        const timezoneArray = state.timeZones
        return timezoneArray.map((timezone) => {
            return {
                'label': timezone[1],
                'timezone': timezone[0],
            }
        })
    },
    eventBlocks (state, getters) {
        const allEvents = getters.events
        return allEvents.map(event => {
            return {
                id: event.id,
                start: event.startUTC,
                end: event.endUTC,
                type_id: event.type_id,
                eventType: event.eventType.name
            }
        })
    },
    customTimeSlots(state){
        return state.customTimeSlots
    },
    appointments (state) {
        return state.appointments
    },
}
